(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentCategoryAccess', AgentCategoryAccess);

    AgentCategoryAccess.$inject = ['$resource'];

    function AgentCategoryAccess($resource) {
        var resourceUrl = 'api/agent-category-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
